import { mapGetters, mapActions, mapMutations } from "vuex";

import * as paymentsStore from "@/store/Payments";

export { paymentsStore };

/**
 * Search store.
 *
 * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
 */
export const createPaymentsMixin = (without = []) => {
  const actions = !without.includes("actions")
    ? mapActions(paymentsStore.moduleName, Object.keys(paymentsStore.actionTypes))
    : {};
  const getters = !without.includes("getters")
    ? mapGetters(paymentsStore.moduleName, Object.keys(paymentsStore.getterTypes))
    : {};
  const mutations = !without.includes("mutations")
    ? mapMutations(paymentsStore.moduleName, Object.keys(paymentsStore.mutationTypes))
    : {};

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  };
};
